import { PORTAL_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/portal_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['clientPortals']);

export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
